module.exports = __webpack_public_path__ + "static/media/OrgSearch.9e7b52dd.svg";